import React from 'react';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import useURLParams from '../hooks/useURLParams';
import UploadLabel from '../pages/UploadLabel';
import ProjectNavigation from '../components/ProjectNavigation';
import ProjectDetailsTitleBar from '../components/ProjectDetailsTitleBar';
import { useProjectDetailsContext } from '../contexts/ProjectDetailsContext';
import Spinner from '../components/Spinner';
import LabelOverview from '../components/LabelOverview';
import LabelDetails from '../components/LabelDetails';
import LabelContextProvider from '../providers/LabelContextProvider';
import { NavigateWithinProject } from '../utils/navigation';
import PackCopyOverview from '../components/PackCopyOverview';
import PackCopyDetails from '../components/PackCopyDetails';
import PackCopyContextProvider from '../providers/PackCopyContextProvider';
import UploadPackCopy from './UploadPackCopy';
const ProjectDetails: React.FC = () => {
    const { getParam } = useURLParams();
    const {
        state: { project, loadingState, errorMessage },
    } = useProjectDetailsContext();

    if (loadingState === 'loading') {
        return <Spinner text="Loading..." />;
    }
    if (loadingState === 'error' || !project) {
        return (
            <Spinner errorMessage={errorMessage || 'Error loading project'} />
        );
    }

    return (
        <>
            {getParam('modal') === 'new-label' && (
                <UploadLabel projectId={project.id} />
            )}
            {getParam('modal') === 'new-pack-copy' && (
                <UploadPackCopy projectId={project.id} />
            )}

            <div className="project-details">
                {/* Route structure with nested routes */}
                <Routes>
                    {/* Base routes with navigation */}
                    <Route
                        path="/"
                        element={
                            <>
                                <ProjectDetailsTitleBar
                                    projectName={project.name}
                                />
                                <ProjectNavigation />
                                <div className="project-content">
                                    <Outlet />
                                </div>
                            </>
                        }
                    >
                        <Route
                            path="pack-copies"
                            element={<PackCopyOverview />}
                        />
                        <Route path="labels" element={<LabelOverview />} />
                        <Route
                            path=""
                            element={<NavigateWithinProject to="labels" />}
                        />
                    </Route>

                    <Route
                        path="pack-copies/:packCopyId"
                        element={
                            <PackCopyContextProvider>
                                <ProjectDetailsTitleBar
                                    projectName={project.name}
                                    detailView="pack copy"
                                />
                                <PackCopyDetails />
                            </PackCopyContextProvider>
                        }
                    />

                    <Route
                        path="labels/:labelId"
                        element={
                            <LabelContextProvider>
                                <ProjectDetailsTitleBar
                                    projectName={project.name}
                                    detailView="label"
                                />
                                <LabelDetails />
                            </LabelContextProvider>
                        }
                    />
                </Routes>
            </div>
        </>
    );
};

export default ProjectDetails;
